import { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StoreActions from '~redux/Stores/actions';

import { DEBOUNCE_TIME } from './constants';

const useTimeModifier = ({ deliveryWaitTime, pickUpWaitTime }) => {
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);

  const { storeSelected } = useSelector((state) => state.core);
  const [waitTime, setWaitTime] = useState({
    deliveryWaitTime,
    pickUpWaitTime
  });

  useEffect(() => {
    setWaitTime({ deliveryWaitTime, pickUpWaitTime });
  }, [deliveryWaitTime, pickUpWaitTime]);

  const onTimeChange = useCallback(
    (waitTime) => {
      dispatch(
        StoreActions.updateStore({
          store: { id: storeSelected, ...waitTime }
        })
      );
    },
    [dispatch, storeSelected]
  );

  const onWaitTimeChange = useCallback(
    (value, name) => {
      let newWaitTime;
      setWaitTime((time) => {
        newWaitTime = { ...time, [name]: value };
        return newWaitTime;
      });

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => onTimeChange(newWaitTime), DEBOUNCE_TIME);
    },
    [onTimeChange]
  );

  return { waitTime, onWaitTimeChange };
};

export default useTimeModifier;
